module.exports = __webpack_public_path__ + "static/img/15.4479c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/15.png
// module id = F1Bj
// module chunks = 0